import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccessControlEmployerState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: AccessControlEmployerState = {
  data: [],
  isLoading: false,
  error: null,
};

const accessControlEmployerSlice = createSlice({
  name: 'accessControlEmployers',
  initialState,
  reducers: {
    setAccessControlEmployers: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAccessControlEmployersLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setAccessControlEmployersError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setAccessControlEmployers, setAccessControlEmployersLoading, setAccessControlEmployersError } =
  accessControlEmployerSlice.actions;

export default accessControlEmployerSlice.reducer;
